<template>
  <div class="editorial">
    <div class="editorial_nav">
      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span> <span class="span2">期刊简介</span>
        </div>
      </div>
      <div style="display: flex">
        <div class="editorial_left">
          <div style="marginbottom: 50px">
            <!-- <button>期刊简介</button> -->
          </div>

          <div class="express_rtitle">
            <div class="waike">杂志简介</div>
            <div class="waixian"></div>
          </div>

          <div class="messageBottom">
            <div>
              <!-- <el-button style="width: 56px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;

line-height: 20px;">杂志简介</el-button> -->
            </div>

            <div class="mainTop">
              <div class="tupian">
                <img src="../../assets/qkfm1 2.png" alt="" />
              </div>

              <div class="wenzi">
                <div>中国循环杂志</div>
                <div>
                  <h5>CSTPCD(2019)</h5>
                  <div>主办单位：<span>国家心血管病中心</span></div>
                  <div>月刊 语种：<span>中文</span></div>
                  <div>国际刊号：<span>1000-3614</span></div>
                  <div>国内刊号：<span>11-2212/R</span></div>
                </div>
              </div>

              <div class="wenzi">
                <div>
                  <div>出版地：<span>国家心血管病中心</span></div>
                  <div>语种：<span>中文</span></div>
                  <div>开发：<span>大16开</span></div>
                  <div>邮发代号：<span>82-212</span></div>
                  <div>单价：<span>30元/每本</span></div>
                </div>
              </div>
            </div>

            <div class="jianjie" v-html="content"></div>
          </div>
        </div>

        <div class="editorial_right">
          <advertisement :num="num" :list2="list2"></advertisement>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue";

export default {
  components: {
    advertisement,
  },
  data() {
    return {
      content: "",
      currentPage3: 1, //当前页数
      total: 0, //总条数
      limit: 20, //每页显示
      kai: 1,
      mo: 1,
      num: {
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      }, //控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: "多西他赛对进展期胃癌术后化疗疗效影响向...",
        },
        {
          id: 2,
          txt: "中国腹腔镜减重代谢外科20年研究文献分析...",
        },
      ],
      //详情
      list: [],
    };
  },

  methods: {
    index() {
      this.GetHomePageBlockInfo(2403);
      this.total = this.list.length;
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.GetHomePageBlockInfo(2403);
      console.log(`当前页: ${val}`);
    },

    GetHomePageBlockInfo(ChannelId) {
      var that = this;
      that.$httphelper
        .GetHomePageBlockInfo({
          journalId: 201607080003,
          pChannelId: 0,
          channelId: ChannelId,
          jChannelID: 0,
          dataSourceType: 1,
          dataShowType: 1,
          curr: that.currentPage3,
          limit: that.limit,
        })
        .then((res) => {
          if (res.code == 200) {
            that.list = res.data || "";
            console.log(that.list, "12312312");
            that.total = res.totalcount;
            that.hide = true;
            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        });
    },
    //鼠标悬停
    addtop(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.list.length; i++) {
          if (id == this.list[i].contentId) {
            this.list[i].zt = true;
            this.list.push("1");
            this.list.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.list.length; i++) {
          this.list[i].zt = false;
          this.list.push("1");
          this.list.pop("1");
        }
      }
    },
    GetContentInfo() {
      this.$httphelper
        .GetContentInfo({
          journalId: 201607080003,
          year: 0,
          issue: 0,
          channelId: 2936,
          contentId: 169166,
          dataSourceType: 1,
          dataShowType: 1,
        })
        .then((res) => {
          this.content = res.data.siteContentInfoResult.content;
        });
    },
  },
  created() {
    this.index();
    this.GetContentInfo();
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.editorial {
  width: 100%;
  min-width: 1366px;
  background-color: #ffffff;
  .editorial_nav {
    width: 85%;
    margin: 0 auto;
    // overflow: auto;
    .editorial_txt {
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      display: flex;
      .evolution_tu {
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2 {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left {
      width: 72%;
      margin-right: 3%;
      float: left;
      .messageBottom {
        width: 100%;
        // margin-top: 200px;
        // height: 210px;

        .mainTop {
          width: 100%;
          overflow: hidden;
          display: flex;
          .tupian {
            width: 20%;
            float: left;
            img {
              width: 100%;
            }
          }
          .wenzi {
            font-size: 22px;
            float: left;
            margin-left: 30px;
            margin-top: 50px;
            margin-right: 100px;
            div {
              font-size: 17px;
              div {
                margin-top: 5px;
              }
              span {
                font-size: 13px;
                // color: #f3f3f3;
              }
            }
          }
        }

        .jianjie {
          width: 100%;
          clear: both;
          // line-height: 100px;
          span {
            margin-top: 50px;
            display: inline-block;
          }
        }
      }
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #dbdbdb;
        padding-bottom: 11px;
        position: relative;
        margin-bottom: 20px;
        // margin-top: 150px;
        display: flex;
        .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2a2d3e;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }

      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .topContent {
          border: 1px solid #ccc;
          margin: 0 auto;
          width: 50%;
          height: 300px;
        }

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #ebebeb;
          line-height: 62px;
          display: flex;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #dbdbdb;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              display: flex;
              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;
            display: flex;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination {
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right {
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/guide.vue